import PoweredByPaypalSVG from 'app/assets/icons/powered-by-paypal.svg'
import PoweredByStripeSVG from 'app/assets/icons/powered-by-stripe.svg'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { PAYMENT_CARDS_STATUS } from 'app/utils/constants/status.constants'

const poweredLogos = {
  stripe: <PoweredByStripeSVG />,
  paypal: <PoweredByPaypalSVG />
}

interface PoweredLogoProps {
  paymentMethod: CheckoutPayment
}

const PoweredLogo: RFC<PoweredLogoProps> = ({ paymentMethod }) => {
  const isBoth = paymentMethod === PAYMENT_CARDS_STATUS.both
  const currentLogo = poweredLogos[paymentMethod]

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Text variant="body2">Powered by</Text>

      {isBoth && (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          {poweredLogos.stripe}

          <Text variant="body2">and</Text>

          {poweredLogos.paypal}
        </Stack>
      )}

      {!isBoth && currentLogo}
    </Stack>
  )
}

export default PoweredLogo
